import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import set from 'lodash/set';
import get from 'lodash/get';
import {
	NOMINEE_INFO,
	NOMINEE_VALUE_TYPE,
	BUSINESS_INFO,
	CORPORATION_INFO,
	REFUND_ACCOUNT_INFO,
	ADDRESS_INFO,
	CUSTOMER_INFO,
} from 'app/constants/escrow-v2';

const CHANGE_FORM = 'escrow-v2.form/CHANGE_FORM';
const changeForm = createAction(CHANGE_FORM);

const initialState = {
	isSameNominee: false,
	nomineeValueType: NOMINEE_VALUE_TYPE.PERSONAL,
	nomineeInfo: NOMINEE_INFO,
	postalAddressInfo: ADDRESS_INFO,
	businessInfo: BUSINESS_INFO,
	corporationInfo: CORPORATION_INFO,
	refundAccountInfo: REFUND_ACCOUNT_INFO,
	customerInfo: CUSTOMER_INFO,
	redirectURL: '',
	backURL: '',
};

export const actions = {
	changeForm,
};

export default handleActions(
	{
		[CHANGE_FORM]: (state, action) =>
			produce(state, (draft) => {
				const values = action.payload;

				Object.keys(values).forEach((key) => {
					set(draft, key, get(values, key));
				});
			}),
	},
	initialState,
);
